export default [
  {
    path: '/postings/cash-deposit',
    name: 'cash-deposit',
    component: () => import('@/views/pages/posting-management/deposit/cash-deposit/Index.vue'),
    meta: {
      pageTitle: 'Cash Deposit',
      hasPermission: 'VIEW_CASH_DEPOSIT_POSTING_LIST',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cash Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/cash-withdrawal-list',
    name: 'cash-withdrawal-list',
    component: () => import('@/views/pages/posting-management/withdrawal/cash-withdrawal/Index.vue'),
    meta: {
      pageTitle: 'Cash Withdrawal',
      hasPermission: 'VIEW_CASH_WITHDRAWAL_POSTING_LIST',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cash Withdrawal',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/cash-withdrawal',
    name: 'cash-withdrawal',
    component: () => import('@/views/pages/posting-management/withdrawal/cash-withdrawal/CashWithdrawal.vue'),
    meta: {
      pageTitle: 'Cash Withdrawal',
      hasPermission: 'CASH_WITHDRAWAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cash Withdrawal',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/add-cash-deposit',
    name: 'add-cash-deposit',
    component: () => import('@/views/pages/posting-management/deposit/cash-deposit/CashDeposit.vue'),
    meta: {
      pageTitle: 'Cash Deposit',
      hasPermission: 'CASH_DEPOSIT_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cash Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/gl-posting',
    name: 'gl-posting',
    component: () => import('@/views/pages/posting-management/gl-posting/Single/GLPosting.vue'),
    meta: {
      pageTitle: 'GL Posting',
      hasPermission: 'SINGLE_JOURNAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'GL Posting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/gl-posting-list',
    name: 'gl-posting-list',
    component: () => import('@/views/pages/posting-management/gl-posting/Single/Index.vue'),
    meta: {
      pageTitle: 'GL Posting',
      hasPermission: 'VIEW_SINGLE_JOURNAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'GL Posting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/cheque-deposit-list',
    name: 'cheque-deposit-list',
    component: () => import('@/views/pages/posting-management/deposit/cheque-deposit/Index.vue'),
    meta: {
      pageTitle: 'Cheque Deposit',
      hasPermission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cheque Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/cheque-deposit',
    name: 'cheque-deposit',
    component: () => import('@/views/pages/posting-management/deposit/cheque-deposit/ChequeDeposit.vue'),
    meta: {
      pageTitle: 'Cheque Deposit',
      hasPermission: 'OUTWARD_CHEQUE_DEPOSIT_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cheque Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/correspondent-bank-deposit',
    name: 'correspondent-bank-deposit',
    component: () => import('@/views/pages/posting-management/deposit/CorrespondentBankDeposit.vue'),
    meta: {
      pageTitle: 'Correspondent Bank Deposit',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cheque Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/cheque-withdrawal-list',
    name: 'cheque-withdrawal-list',
    component: () => import('@/views/pages/posting-management/withdrawal/cheque-withdrawal/Index.vue'),
    meta: {
      pageTitle: 'Cheque Withdrawal',
      hasPermission: 'VIEW_CHEQUE_WITHDRAWAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cheque Withdrawal',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/cheque-withdrawal',
    name: 'cheque-withdrawal',
    component: () => import('@/views/pages/posting-management/withdrawal/cheque-withdrawal/ChequeWithdrawal.vue'),
    meta: {
      pageTitle: 'Cheque Withdrawal',
      hasPermission: 'CHEQUE_WITHDRAWAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cheque Withdrawal',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/correspondent-bank-withdrawal',
    name: 'correspondent-bank-withdrawal',
    component: () => import('@/views/pages/posting-management/withdrawal/CorrespondentBankWithdrawal.vue'),
    meta: {
      pageTitle: 'Correspondent Withdrawal',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Cheque Deposit',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/postings/single-gl',
  //   name: 'single-gl',
  //   component: () => import('@/views/pages/posting-management/single-batch/SingleGl.vue'),
  //   meta: {
  //     pageTitle: 'Single GL (Only)',
  //     breadcrumb: [
  //       {
  //         text: 'Postings',
  //       },
  //       {
  //         text: 'Single GL (Only)',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/postings/batch-gl-list',
    name: 'batch-gl-list',
    component: () => import('@/views/pages/posting-management/gl-posting/Batch/Index.vue'),
    meta: {
      pageTitle: 'Batch GL',
      hasPermission: 'VIEW_BATCH_JOURNAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch GL',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/batch-gl',
    name: 'batch-gl',
    component: () => import('@/views/pages/posting-management/gl-posting/Batch/BatchGLPosting.vue'),
    meta: {
      pageTitle: 'Batch GL',
      hasPermission: 'BATCH_JOURNAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch GL',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/batch-gl-customer-list',
    name: 'batch-gl-customer-list',
    component: () => import('@/views/pages/posting-management/gl-posting/BatchGLCustomer/Index.vue'),
    meta: {
      pageTitle: 'Batch GL And Customer',
      hasPermission: 'BATCH_GL_CUSTOMER_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch GL And Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/batch-gl-customer',
    name: 'batch-gl-customer',
    component: () => import('@/views/pages/posting-management/gl-posting/BatchGLCustomer/BatchGLCustomerPosting.vue'),
    meta: {
      pageTitle: 'Batch GL And Customer',
      hasPermission: 'BATCH_GL_CUSTOMER_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch GL And Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/batch-customer-deposit',
    name: 'batch-customer-deposit',
    component: () => import('@/views/pages/posting-management/single-batch/BatchCustomerDeposit.vue'),
    meta: {
      pageTitle: 'Batch Customer Deposit',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch Customer Deposit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/batch-customer-withdrawal',
    name: 'batch-customer-withdrawal',
    component: () => import('@/views/pages/posting-management/single-batch/BatchCustomerWithdrawal.vue'),
    meta: {
      pageTitle: 'Batch Customer Withdrawal',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch Customer Withdrawal',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/batch-gl-customer',
    name: 'batch-gl-customer',
    component: () => import('@/views/pages/posting-management/single-batch/BatchGlAndCustomer.vue'),
    meta: {
      pageTitle: 'Batch GL And Customer',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch GL And Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/batch-gl-upload',
    name: 'batch-gl-upload',
    component: () => import('@/views/pages/posting-management/single-batch/BatchGlUpload.vue'),
    meta: {
      pageTitle: 'Batch GL Upload',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch GL Upload',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/cancel-posting-list',
    name: 'cancel-posting-list',
    component: () => import('@/views/pages/posting-management/reversal/cancel-posting/Index.vue'),
    meta: {
      pageTitle: 'Same Day Cancel',
      hasPermission: 'CANCEL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Same Day Cancel',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/cancel-posting',
    name: 'cancel-posting',
    component: () => import('@/views/pages/posting-management/reversal/cancel-posting/CancelPosting.vue'),
    meta: {
      pageTitle: 'Same Day Cancel',
      hasPermission: 'CANCEL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Same Day Cancel',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/single-reversal-list',
    name: 'single-reversal-list',
    component: () => import('@/views/pages/posting-management/reversal/Single/Index.vue'),
    meta: {
      pageTitle: 'Single Reversal',
      hasPermission: 'VIEW_REVERSAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Single Reversal',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/single-reversal',
    name: 'single-reversal',
    component: () => import('@/views/pages/posting-management/reversal/Single/SingleTransaction.vue'),
    meta: {
      pageTitle: 'Single Reversal',
      hasPermission: 'REVERSAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Single Reversal',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/batch-reversal',
    name: 'batch-reversal',
    component: () => import('@/views/pages/posting-management/reversal/BatchTransaction.vue'),
    meta: {
      pageTitle: 'Batch Reversal',
      hasPermission: 'REVERSAL_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Batch Reversal',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/vault-in-and-out',
    name: 'vault-in-and-out',
    component: () => import('@/views/pages/posting-management/till-vault/VaultInAndOut.vue'),
    meta: {
      pageTitle: 'Vault-In & Out',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Vault-In & Out',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/till-to-till-transfer',
    name: 'till-to-till-transfer',
    component: () => import('@/views/pages/posting-management/till-vault/TillToTillTransfer.vue'),
    meta: {
      pageTitle: 'Till to Till Transfer',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Till to Till Transfer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/sell-cash-to-vault',
    name: 'sell-cash-to-vault',
    component: () => import('@/views/pages/posting-management/till-vault/SellCashToVault.vue'),
    meta: {
      pageTitle: 'Sell Cash to Vault',
      hasPermission: 'VIEW_SELL_CASH_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Sell Cash to Vault',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/buy-cash-from-vault',
    name: 'buy-cash-from-vault',
    component: () => import('@/views/pages/posting-management/till-vault/BuyCashFromVault.vue'),
    meta: {
      pageTitle: 'Buy Cash from Vault',
      hasPermission: 'VIEW_BUY_CASH_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Buy Cash from Vault',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/shortage-overage',
    name: 'shortage-overage',
    component: () => import('@/views/pages/posting-management/till-vault/ShortageOverage.vue'),
    meta: {
      pageTitle: 'Shortage/Overage',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Shortage/Overage',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/intra-branch-transaction',
    name: 'intra-bank-transfer-list',
    component: () => import('@/views/pages/posting-management/local-ft/IntraBankTransfer/Index.vue'),
    meta: {
      pageTitle: 'Intra-bank Transfer',
      hasPermission: 'VIEW_LOCAL_FUNDS_TRANSFER_POSTING',
      breadcrumb: [
        {
          text: 'Operations',
        },
        {
          text: 'Intra-bank Transfer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/intra-bank-transfer',
    name: 'intra-bank-transfer',
    component: () => import('@/views/pages/posting-management/local-ft/IntraBankTransfer/IntraBankTransfer.vue'),
    meta: {
      pageTitle: 'Intra-bank Transfer',
      hasPermission: 'LOCAL_FUNDS_TRANSFER_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Intra-bank Transfer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/casa-standing-order',
    name: 'casa-standing-order',
    component: () => import('@/views/pages/posting-management/local-ft/CasaStandingOrder.vue'),
    meta: {
      pageTitle: 'CASA Standing Order',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'CASA Standing Order',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/casa-and-gl-standing-order',
    name: 'casa-and-gl-standing-order',
    component: () => import('@/views/pages/posting-management/local-ft/CasaAndGlStandingOrder.vue'),
    meta: {
      pageTitle: 'CASA & GL Standing Order',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'CASA & GL Standing Order',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/backdate-transaction',
    name: 'backdate-transaction',
    component: () => import('@/views/pages/posting-management/other/BackDateTransaction.vue'),
    meta: {
      pageTitle: 'Backdate Transaction',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Backdate Transaction',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/loan-repayment',
    name: 'loan-repayment',
    component: () => import('@/views/pages/posting-management/other/LoanRepayment.vue'),
    meta: {
      pageTitle: 'Loan Repayment',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Loan Repayment',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/loan-provisioning',
    name: 'loan-provisioning',
    component: () => import('@/views/pages/posting-management/credit-provisioning/LoanProvisioning.vue'),
    meta: {
      pageTitle: 'Loan Provisioning',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Loan Provisioning',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/overdraft-provisioning',
    name: 'overdraft-provisioning',
    component: () => import('@/views/pages/posting-management/credit-provisioning/OverdraftProvisioning.vue'),
    meta: {
      pageTitle: 'Overdraft Provisioning',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Overdraft Provisioning',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/account-closure',
    name: 'account-closure',
    component: () => import('@/views/pages/posting-management/account-closure/Index.vue'),
    meta: {
      pageTitle: 'Account Closure',
      hasPermission: 'VIEW_ACCOUNT_CLOSURE_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Account Closure',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/add-account-closure',
    name: 'add-account-closure',
    component: () => import('@/views/pages/posting-management/account-closure/AccountClosure.vue'),
    meta: {
      pageTitle: 'Account Closure',
      hasPermission: 'ACCOUNT_CLOSURE_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Account Closure',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/fixed-deposit-liquidation',
    name: 'fixed-deposit-liquidation',
    component: () => import('@/views/pages/posting-management/fixed-deposit-posting/fixed-deposit-liquidation/Index.vue'),
    meta: {
      pageTitle: 'Fixed Deposit Liquidation',
      hasPermission: 'VIEW_LIQUIDATE_FIXED_DEPOSIT',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Fixed Deposit Liquidation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/add-fixed-deposit-liquidation',
    name: 'add-fixed-deposit-liquidation',
    component: () => import('@/views/pages/posting-management/fixed-deposit-posting/fixed-deposit-liquidation/FixedDepositLiquidation.vue'),
    meta: {
      pageTitle: 'Fixed Deposit Liquidation',
      hasPermission: 'LIQUIDATE_FIXED_DEPOSIT_ACCOUNT',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Fixed Deposit Liquidation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/fixed-deposit-top-up',
    name: 'fixed-deposit-top-up',
    component: () => import('@/views/pages/posting-management/fixed-deposit-posting/fixed-deposit-topup/Index.vue'),
    meta: {
      pageTitle: 'Fixed Deposit Top-up',
      hasPermission: 'VIEW_FIXED_DEPOSIT_TOP_UP',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Fixed Deposit Top-up',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/add-fixed-deposit-top-up',
    name: 'add-fixed-deposit-top-up',
    component: () => import('@/views/pages/posting-management/fixed-deposit-posting/fixed-deposit-topup/FixedDepositTopup.vue'),
    meta: {
      pageTitle: 'Fixed Deposit Top-up',
      hasPermission: 'FIXED_DEPOSIT_TOP_UP',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Fixed Deposit Top-up',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/backdating-posting',
    name: 'backdating-posting',
    component: () => import('@/views/pages/posting-management/back-dating-posting/Index.vue'),
    meta: {
      pageTitle: 'Backdating Posting',
      hasPermission: 'VIEW_BACKDATING_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Backdating Posting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/add-backdating-posting',
    name: 'add-backdating-posting',
    component: () => import('@/views/pages/posting-management/back-dating-posting/BackDatingPosting.vue'),
    meta: {
      pageTitle: 'Backdating Posting',
      hasPermission: 'BACKDATING_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'Backdating Posting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/postings/end-of-year-closure',
    name: 'end-of-year-closure',
    component: () => import('@/views/pages/posting-management/eoy-closure-posting/EOYClosure.vue'),
    meta: {
      pageTitle: 'End Of Year Closure',
      hasPermission: 'END_OF_YEAR_POSTING',
      breadcrumb: [
        {
          text: 'Postings',
        },
        {
          text: 'End Of Year Closure',
          active: true,
        },
      ],
    },
  },
]
